import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function centrocusto(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@centrocusto/FIND_CENTROCUSTO':
      case '@centrocusto/UPDATE_CENTROCUSTO':
      case '@centrocusto/DELETE_CENTROCUSTO':
      case '@centrocusto/STORE_CENTROCUSTO':
      case '@centrocusto/CENTROSCUSTOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@centrocusto/SUCCESS_REMOVE':
      case '@centrocusto/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@centrocusto/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.centroscustos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@centrocusto/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.centrocusto;
        break;
      }

      case '@centrocusto/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
